module.exports = __webpack_public_path__ + "static/img/xinqingtang.ab27c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/xinqingtang.png
// module id = /Lfo
// module chunks = 0